import { TICKET_CALENDAR_SEARCH_START_LOADING, TICKET_CALENDAR_SEARCH_END_LOADING, TICKET_CALENDAR_SEARCH_LOADED, SET_TICKET_CALENDAR_FILTER } from "../constants/TicketCalendarConstants";

const initialState = {
    loading: false,
    fbo: null,
    filter: {
        search: "",
        userId: ""
    }
};

const TicketCalendarReducer = (state = initialState, action) => {
    switch(action.type) {
        case TICKET_CALENDAR_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case TICKET_CALENDAR_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case TICKET_CALENDAR_SEARCH_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        case SET_TICKET_CALENDAR_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        default:
            return state;
    }
}

export default TicketCalendarReducer;
